import SearchBar from './Components/SearchBar/SearchBar';

function App() {
  return (
    <div className="wrapper">
      <div className="container">
        <SearchBar/>
      </div>
    </div>
  );
}

export default App;